import {Component, Input, OnInit} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";

export type ActivePaneType = "left" | "right";

@Component({
	selector: "sim-slide-panel",
	templateUrl: "./slide-panel.component.html",
	styleUrls: ["./slide-panel.component.scss"],
	animations: [
		trigger("slide", [
			state("left", style({transform: "translateX(0)"})),
			state("right", style({transform: "translateX(-50%)"})),
			transition("* => *", animate(175)),
		]),
	],
	standalone: false,
})
export class SlidePanelComponent {
	@Input() activePane: ActivePaneType = "left";

	constructor() {}
}
